exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".agents-oferta-page[data-v-0baabec0]{padding:20px}", ""]);

// exports
